import ReactGA from 'react-ga4';

export const WHATSAPP_NUMBER = '918111064592';
export const PHONE_DISPLAY = '+91 8111064592';

const isPrerender = () => typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';

// GA4 is initialised in src/index.js; every call here is a no-op while pre-rendering.
export const trackEvent = (name, params = {}) => {
  try {
    if (isPrerender()) return;
    ReactGA.event(name, params);
  } catch (e) {
    // analytics must never break the page
  }
};

export const trackPageView = (path) => {
  try {
    if (isPrerender()) return;
    ReactGA.send({ hitType: 'pageview', page: path });
  } catch (e) {
    // analytics must never break the page
  }
};

export const whatsappUrl = (text = 'Hi, I would like to know more about Pro Solutions ERP for my school.') =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

const ATTRIBUTION_KEY = 'ps_attribution';

// Remember where the visitor first came from so a lead submitted three pages
// later still carries the original campaign / referrer.
export const captureAttribution = () => {
  if (typeof window === 'undefined' || isPrerender()) return;
  try {
    if (sessionStorage.getItem(ATTRIBUTION_KEY)) return;
    const params = new URLSearchParams(window.location.search);
    sessionStorage.setItem(
      ATTRIBUTION_KEY,
      JSON.stringify({
        utm_source: params.get('utm_source'),
        utm_medium: params.get('utm_medium'),
        utm_campaign: params.get('utm_campaign'),
        referral_url: document.referrer || null,
      })
    );
  } catch (e) {
    // storage can be blocked; attribution is best-effort
  }
};

const readAttribution = () => {
  try {
    const raw = sessionStorage.getItem(ATTRIBUTION_KEY);
    if (!raw) return {};
    const a = JSON.parse(raw);
    return {
      utm_source: a.utm_source ? String(a.utm_source).slice(0, 100) : undefined,
      utm_medium: a.utm_medium ? String(a.utm_medium).slice(0, 100) : undefined,
      utm_campaign: a.utm_campaign ? String(a.utm_campaign).slice(0, 100) : undefined,
      referral_url: a.referral_url || undefined,
    };
  } catch (e) {
    return {};
  }
};

// Posts to the existing public POST /website-query endpoint (stored in website_enquiries).
export const submitLead = async (payload) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/website-query`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...readAttribution(), ...payload }),
    });
    const data = await response.json();
    if (response.ok && data.success) {
      trackEvent('generate_lead', { lead_source: payload.source, enquiry_type: payload.enquiry_type });
      return { ok: true };
    }
    return { ok: false, error: data.error };
  } catch (e) {
    return { ok: false, network: true };
  }
};
